import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Subscribe.scss';
import SubscribeForm from './SubscribeForm';
import logo from '../assets/RGB_LilyLaiLogo_Black.png';
import { Helmet } from 'react-helmet-async';

function Subscribe() {
  return (
    <>
      <Helmet>
        <title>Join the Newsletter | Lily Lai Real Estate</title>
        <meta name='description' content='Market Notes, delivered gently — a few thoughtful emails a month on the Bay Area market from Lily Lai. No noise, no pressure.' />
        <meta name='robots' content='noindex, follow' />
      </Helmet>

      <div className='subscribe-page'>
        <Link to='/' className='subscribe-brand'>
          <img src={logo} alt='Lily Lai Real Estate' className='subscribe-brand-logo' />
        </Link>

        <div className='subscribe-card'>
          <p className='subscribe-eyebrow'>Market Notes</p>
          <h1 className='subscribe-title'>Join the Newsletter</h1>
          <p className='subscribe-subtitle'>
            Bringing you real estate vibes &amp; good energy, a few times a month.
          </p>
          <SubscribeForm />
        </div>
      </div>
    </>
  );
}

export default Subscribe;
